<template>
    <form ref="form" @submit.prevent="save">
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">락커</span>
            <span class="txt">
                센터에서 사용 중인 락커에대해 기본설정을 진행합니다. 락커대여 내역을 확인하고 싶으시다면,
                회원>락커대여내역 메뉴에서 확인하시면 됩니다.
            </span>
        </div>

        <div v-if="prodNo" class="locker-info-card">
            <div class="txt-box">
                <span class="txt">{{ data.name }}</span>
            </div>
            <div class="info-box">
                <span v-if="data.useYn" class="ic">사용중</span>
                <span v-else class="ic red">미사용</span>
                <small>
                    <span v-if="data.lockerSex == 'M'">남자</span>
                    <span v-else-if="data.lockerSex == 'W'">여자</span>
                    <span v-else>공통</span>
                    / {{ data.lockNumberRangeStart }}~{{ data.lockNumberRangeEnd }}
                </small>
                <span v-if="data.lockerFixPriceYn" class="txt">
                    1개월 고정금액 {{ data.lockerFixPrice | numberFormatFilter }}
                </span>
                <span v-else class="txt">개월별 차등금액</span>
            </div>
        </div>

        <p class="sub-title">
            기본정보
            <button v-if="prodNo" class="com-btn red right" type="button" @click="remove">삭제</button>
        </p>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <div class="line">
                        <span class="tit">
                            락커명
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input
                                v-model="data.name"
                                class="w640"
                                maxlength="10"
                                placeholder="예 ) 복도앞 락커"
                                required
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">설명</span>
                        <div class="input-cnt">
                            <input v-model="data.productComment" class="w640" maxlength="50" type="text" />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">성별구분</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input id="radio-1-1" v-model="data.lockerSex" name="radio-1" type="radio" value="-" />
                                <label for="radio-1-1">공통</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-1-2" v-model="data.lockerSex" name="radio-1" type="radio" value="M" />
                                <label for="radio-1-2">남자</label>
                            </div>
                            <div class="com-radio">
                                <input id="radio-1-3" v-model="data.lockerSex" name="radio-1" type="radio" value="W" />
                                <label for="radio-1-3">여자</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            락커번호
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input
                                v-model="data.lockNumberRangeStart"
                                class="w60 center"
                                maxlength="3"
                                required
                                type="number"
                                @change="
                                    (e) => {
                                        parseInt(e.target.value) < 0 ? (e.target.value = 0) : '';
                                    }
                                "
                            />
                            ~
                            <input
                                v-model="data.lockNumberRangeEnd"
                                class="w60 center"
                                maxlength="3"
                                required
                                type="number"
                                @change="
                                    (e) => {
                                        parseInt(e.target.value) < 0 ? (e.target.value = 0) : '';
                                    }
                                "
                            />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            금액설정
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="sub-box w210">
                                <div class="com-radio">
                                    <input
                                        id="radio-2-1"
                                        v-model="data.lockerFixPriceYn"
                                        :value="true"
                                        name="radio-2"
                                        type="radio"
                                        @change="
                                            (e) => {
                                                parseInt(e.target.value) < 0 ? (e.target.value = 0) : '';
                                            }
                                        "
                                    />
                                    <label for="radio-2-1">1개월 고정금액</label>
                                </div>
                                <div class="month-input">
                                    <span class="tit">1개월 당</span>
                                    <div class="won">
                                        <input v-model="data.lockerFixPrice" class="w60" maxlength="10" type="number" />
                                        <span class="txt">원</span>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-box w380">
                                <div class="com-radio">
                                    <input
                                        id="radio-2-2"
                                        v-model="data.lockerFixPriceYn"
                                        :value="false"
                                        name="radio-2"
                                        type="radio"
                                    />
                                    <label for="radio-2-2">개월별 차등금액</label>
                                </div>
                                <div class="month-table">
                                    <table>
                                        <colgroup>
                                            <col style="width: 100px" />
                                            <col style="width: 160px" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>개월</th>
                                                <th>금액</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(price, i) in data.lockerMonPrice" :key="i">
                                                <!--<td>{{ i + 1 }}</td>-->
                                                <td>
                                                    <input
                                                        v-model="data.lockerMonMonth[i]"
                                                        class="w100p"
                                                        maxlength="2"
                                                        type="number"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        v-model="data.lockerMonPrice[i]"
                                                        class="w100"
                                                        maxlength="10"
                                                        type="number"
                                                    />
                                                    <small>원</small>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <button
                                        v-if="this.data.lockerMonPrice.length < 5"
                                        class="com-btn"
                                        type="button"
                                        @click="addMonPrice"
                                    >
                                        + 추가
                                    </button>
                                    <button
                                        v-if="this.data.lockerMonPrice.length < 5"
                                        class="com-btn red"
                                        type="button"
                                        @click="delMonPrice"
                                    >
                                        - 삭제
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">사용여부</span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input
                                    id="radio-3-1"
                                    v-model="data.useYn"
                                    :value="true"
                                    name="radio-3"
                                    required
                                    type="radio"
                                />
                                <label for="radio-3-1">사용중</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-3-2"
                                    v-model="data.useYn"
                                    :value="false"
                                    name="radio-3"
                                    required
                                    type="radio"
                                />
                                <label for="radio-3-2">미사용</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <router-link :to="{ name: 'SettingLocker', query: $route.query }" class="com-btn" type="reset">
                취소
            </router-link>
            <button :disabled="isLoading" class="com-btn blue" type="submit">등록</button>
        </div>
    </form>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingLockerEdit',
    props: ['prodNo'],
    components: { LoadingSpinner },
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            data: { lockerMonMonth: [1], lockerMonPrice: [0], useYn: true, lockerSex: '-' },
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            if (!this.prodNo) return;
            this.isLoading = true;
            api.get(`/admin/api/locker/group/${this.centerId}/${this.prodNo}`, {
                params: {
                    ...this.$route.query,
                    limit: 1,
                    centerProductId: this.prodNo,
                },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data[0];
                    this.data.lockerMonMonth = [];
                    this.data.lockerMonPrice = [];
                    _.range(1, 6).forEach((i) => {
                        if (this.data[`lockerMon${i}Price`]) {
                            this.data.lockerMonMonth.push(this.data[`lockerMon${i}Month`]);
                            this.data.lockerMonPrice.push(this.data[`lockerMon${i}Price`]);
                        }
                    });
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = { lockerMonMonth: [0], lockerMonPrice: [0] };
                    if (res.response.status != 404 || this.prodNo)
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        addMonPrice() {
            this.data.lockerMonMonth.push(1);
            this.data.lockerMonPrice.push(0);
            this.$forceUpdate();
        },
        save() {
            if (!this.$refs.form.checkValidity() || this.isLoading) {
                return;
            }

            this.isLoading = true;
            let data = {
                centerId: this.centerId,
                centerProductId: this.data.centerProductId,
                name: this.data.name,
                productComment: this.data.productComment,
                lockerSexType: this.data.lockerSex,
                lockNumberRangeStart: this.data.lockNumberRangeStart,
                lockNumberRangeEnd: this.data.lockNumberRangeEnd,
                lockerFixPriceYn: this.data.lockerFixPriceYn,
                lockerFixPrice: this.data.lockerFixPrice,
                centerLockerPriceRanges: [],
                useYn: this.data.useYn,
            };
            _.range(1, 6).forEach((i) => {
                data.centerLockerPriceRanges.push({
                    lockerMonMonth: 1 * this.data.lockerMonMonth[i - 1],
                    lockerMonPrice: 1 * this.data.lockerMonPrice[i - 1],
                });
            });
            (this.data.centerProductId ? api.put : api.post)('/admin/api/locker', data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    this.$router.push({ name: 'SettingLocker' });
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        remove(event) {
            if (
                !confirm(
                    `${this.data.name} ${this.data.lockNumberRangeStart}~${this.data.lockNumberRangeEnd}번에 대여된 락커내역이 모두 삭제됩니다.\n정말로 삭제하시겠습니까??`
                )
            ) {
                return;
            }
            event.target.disabled = true;
            api.delete(
                `/admin/api/locker/${this.centerId}?centerProductId=${this.data.centerProductId}&centerProductVersion=${this.data.centerProductVersion}`
            )
                .then((res) => {
                    alert('삭제했습니다.');
                    this.$router.push({ name: 'SettingLocker', query: this.$route.query });
                })
                .catch((res) => {
                    event.target.disabled = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        delMonPrice() {
            // 삭제기능
            this.data.lockerMonMonth.pop(1);
            this.data.lockerMonPrice.pop(0);
            this.$forceUpdate();
        },
    },
};
</script>
<style lang="scss"></style>
